import script from "./HelpMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./HelpMessage.vue?vue&type=script&setup=true&lang=js"

import "./HelpMessage.vue?vue&type=style&index=0&id=1804f756&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1804f756"]])

export default __exports__